import { BASE } from './index';
import axios from './http';
const fr = {
    // 获取运费减免列表
    platformfreightdiscountlist: params => axios.post(`${BASE.PRO1}/platform/freight/discount/list`,  params ),

    // 获取运费减免列表
    platformfreightdiscountproductinfo: params => axios.post(`${BASE.PRO1}/platform/freight/discount/product/info`,  params ),
    // 保存运费减免记录（新增或更新）
    platformfreightdiscountproductsave: params => axios.post(`${BASE.PRO1}/platform/freight/discount/save`,  params ),


};

export default fr;
